<div class="done-main">
  <div class="w-700 m-auto h-body">
    <div class="flex-1 done-con">
      <i class="done-icon" [ngClass]="[doneIcon, blinkIcon ? 'blink' : '']"></i>
      <p class="done-title">{{ doneTitle }}</p>
      <p class="done-body" [innerHTML]="doneBody"></p>
      <p *ngIf="remainingBalance > 0" class="done-remaining-balance">
        Remaining Balance: {{ displayRemainingBalance }}
      </p>
      <div class="btns-cont" *ngIf="isReactNative || isWebLogin">
        <a class="backToHome" (click)="sendClose()">Back To Home</a>
        <a class="logout" (click)="sendLogout()">Logout</a>
      </div>

      <div
        *ngIf="!isReactNative && !isWebLogin"
        class="hide-me-in-app m-t-l d-flex gap-m"
      >
        <a [href]="androidLinke">
          <img
            src="https://res.cloudinary.com/kitchry/image/upload/v1726847930/Images%20for%20app/p-s.png"
            class="download-img"
          />
        </a>
        <a [href]="iosLinke">
          <img
            src="https://res.cloudinary.com/kitchry/image/upload/v1726847930/Images%20for%20app/a-s.png"
            class="download-img"
          />
        </a>
      </div>
    </div>
  </div>
</div>
